export const ADMIN_HOME = 'admin';
export const ADMIN_ROOT = `/${ADMIN_HOME}`;

export const AdminPages = {
    Sites: 'sites',
    BusinessServices: 'business-services',
    Agents: 'nPoints',
    AgentSettings: 'nPoint-settings',
    ServiceTests: 'service-tests',
    MonitoredInfrastructure: 'monitored-infrastructure',
    VirtualInfrastructure: 'virtual-infrastructure',
    Interfaces: 'monitored-interface',
    Polling: 'polling',
    Thresholds: 'thresholds',
    Notifications: 'notifications',
    Syslog: 'syslogCollection',
    AuditActivities: 'auditActivities',
    Users: 'users',
    AgentCertificates: 'certificate',
    VoipConfig: 'voip', // TODO...
    WifiNetworks: 'wifiNetworks',
    WiredNetworks: 'wiredNetworks',
    ApiTokens: 'apiTokens',
    ISNGs: 'isngs',
    Sso: 'sso',
    General: 'config',
    Collectors: 'collectors',
    Licensing: 'license',
    ServerHealth: 'server-health',
    WanInterfaces: 'wanInterfaceConfig',
    Plms: 'plms',
    ActiveStandbyPlms: 'active-standby-plms',
    MaintenanceWindows: 'maintenance-windows',
    Groups: 'groups',
    Dashboards: 'dashboards',
    // Legacy portal/ui route; this path is redirected to /admin/voip/callManagers in React.
    CallManagers: 'callManagers',
};

// This list of pages is used to identify which admin pages are implemented in React.
export const ReactAdminPages = [
    AdminPages.ServiceTests,
    AdminPages.Users,
    AdminPages.WifiNetworks,
    AdminPages.WiredNetworks,
    AdminPages.ApiTokens,
    AdminPages.Sso,
    AdminPages.General,
    AdminPages.Sites,
    AdminPages.WanInterfaces,
    AdminPages.BusinessServices,
    AdminPages.AgentSettings,
    AdminPages.VoipConfig,
    AdminPages.Agents,
    AdminPages.Polling,
    AdminPages.Thresholds,
    AdminPages.AgentCertificates,
    AdminPages.Plms,
    AdminPages.ActiveStandbyPlms,
    AdminPages.ISNGs,
    AdminPages.Licensing,
    AdminPages.AuditActivities,
    AdminPages.ServerHealth,
    AdminPages.MaintenanceWindows,
    AdminPages.Groups,
    AdminPages.Dashboards,
    AdminPages.Collectors,
    AdminPages.VirtualInfrastructure,
    AdminPages.Notifications,
    AdminPages.Syslog,
    AdminPages.MonitoredInfrastructure,
    AdminPages.Interfaces,
];

export const DEFAULT_ID_PROPERTY = '_id';
export const ADMIN_PAGE_ID_PROPERTY_OVERRIDES = {};
